<i18n locale="en">
{
  "pages": {
    "account": "Account",
    "invoices": "Invoices",
    "payouts": "Payouts",
    "subscriptions": "Subscriptions",
    "transactions": "Transactions"
  }
}
</i18n>

<template>
  <DropdownNav v-if="!isNewSidebarEnabled" :nav-items="navItems" />
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import DropdownNav, {
  type DropdownNavItem,
} from '@/components/Navigation/DropdownNav.vue'
import { newSidebarEnabled } from '@/core/nav/utils/newSidebarEnabled'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const { t } = useI18n()

const { isEnabled: isNewSidebarEnabled } = newSidebarEnabled()

const FeatureFlags = useFeatureFlags()

let baseNavItems: DropdownNavItem[] = [
  {
    label: t('pages.payouts'),
    to: { name: 'brand.billing.payouts' },
  },
  {
    label: t('pages.transactions'),
    to: { name: 'brand.billing.transactions' },
  },
  {
    label: t('pages.invoices'),
    to: { name: 'brand.billing.invoices' },
  },
  {
    label: t('pages.subscriptions'),
    to: { name: 'brand.billing.methods' },
  },
  {
    label: t('pages.account'),
    to: { name: 'brand.billing.account' },
  },
]

if (!FeatureFlags.isEnabled('hermes.paymentsAccountManagement')) {
  baseNavItems = baseNavItems.filter(
    (item) => item.label !== t('pages.account')
  )
}

if (!FeatureFlags.isEnabled('hermes.transactionsView')) {
  baseNavItems = baseNavItems.filter(
    (item) => item.label !== t('pages.transactions')
  )
}

const navItems = ref<DropdownNavItem[]>(baseNavItems)
</script>
